import { useAtomValue } from 'jotai';

import { cn, Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@crossnokaye/ux-common';

import { SummaryConfig } from '@repo/sdk/models/components';

import { showMisconfiguredBordersAtom } from '@/features/developer-tools/misconfigured-overlay/misconfigured-overlay.state';

type MisconfiguredAnimaticWrapperProps = {
  children: React.ReactNode;
  className?: string;
  equipment?: SummaryConfig;
};

export const MisconfiguredAnimaticWrapper = ({
  children,
  equipment,
  className,
}: MisconfiguredAnimaticWrapperProps) => {
  const showMisconfiguredBorders = useAtomValue(showMisconfiguredBordersAtom);
  const misconfiguredReasons = equipment?.animatic?.misconfiguredReasons ?? [];

  // If the feature is disabled or there are no misconfigured reasons, render without border
  if (!showMisconfiguredBorders || misconfiguredReasons.length === 0) {
    return className ? <div className={className}>{children}</div> : children;
  }

  const borderClassName = className
    ? cn(className, 'border-ckds-base-caution')
    : 'border-2 border-ckds-base-caution rounded';

  return (
    // Delay duration is set to 50ms
    <Tooltip delayDuration={50}>
      <TooltipTrigger asChild>
        <div className={borderClassName}>{children}</div>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          side="top"
          align="center"
          className="whitespace-pre-line text-ckds-yellow-500 max-h-24 overflow-y-auto"
        >
          {misconfiguredReasons.join('\n')}
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
